// Public UI adapted from Klargo-Reference/lib/utils.ts.
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function formatPrice(price) {
    const priceStr = typeof price === 'number' ? price.toString() : price;
    const numericOnly = priceStr.replace(/\D/g, '');
    return numericOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
